
import * as yup from 'yup';

const minPasswordLen = 12;

/* Please note:  Any modifications to this schema need to be refelected in HostingExtensions.cs and vice versa */
export const passwordSchema = () => {
  return yup
    .string()
    .required('Password is required')
    .min(minPasswordLen, `Password should be of minimum ${minPasswordLen} characters length`);
}

/* Note: this was the original Password Schema for reference
yup
    .string('Enter your password')
    .min(8, 'Passwords must be at least 8 characters')
    .matches(/[A-Z]/, "Passwords must have at least one uppercase ('A'-'Z')")
    .matches(/[a-z]/, "Passwords must have at least one lowercase ('a'-'z')")
    .matches(/\d/, "Passwords must have at least one digit ('0'-'9')")
    .matches(/[^a-zA-Z0-9]/, 'Passwords must have at least one non alphanumeric character')
    .test('unique-chars', 'Passwords must use at least 6 different characters', (value) => {
        if (!value) return true;
        const uniqueChars = new Set(value).size;
        return uniqueChars >= 6;
    })
    .required('Password is required'),
*/

export const confirmPasswordSchema = (passwordField: string = 'password') => {
  
  return yup  
    .string()
    .required('Confirm Password is required')
    .min(minPasswordLen, `Password should be of minimum ${minPasswordLen} characters length`)
    .oneOf([yup.ref(passwordField), null], "Passwords don't match!");
}
